import { Avatar, Box, IconButton, Modal, Rating, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import googleLogo from "../assets/images/google-logo.png"
import { useState } from "react";

const ReviewDetails = (props) => {
  const { open, setOpen, handleOpen, review } = props
  return (
    <>
      <Modal
        open={open}
        onClose={handleOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <Box sx={style}>
        <div className="d-flex flex-row-reverse ">
            <IconButton onClick={handleOpen}>
              <CloseIcon />
            </IconButton>
          </div>
          <div class="d-flex flex-row bd-highlight mb-3">
            <div class="p-2 ">
                
            <Avatar
                // src={googleLogo}
                alt="Customer"
                sx={{
                    width: 60,
                    height: 60,
                    margin: '0 auto',
                    marginBottom: 2,
                }}
            >
              <Typography sx={{ fontSize: "28px" }}>
      {review?.name?.charAt(0).toUpperCase()}
    </Typography>

            </Avatar>
            </div>
            <div class="p-2">
                <h5>
                  {review?.name}
                </h5>
                <Rating name="read-only" value={review?.star} readOnly />
            </div>
            {/* <div class="p-2 ">Flex item 3</div> */}
          </div>
          <div className="p-4">
             <p>
                {review?.review}
             </p>
          </div>
        </Box>

      </Modal>
    </>
  )
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  // p: 4,
  scroll: "auto",
  maxHeight: "90vh",
  overflowY: "auto",
  borderRadius:"10px",
  padding:"20px",
};

export default ReviewDetails;